import React from 'react';
import { motion } from 'framer-motion';
import { Calculator, Settings, HeadphonesIcon, Megaphone, Code2, Users2, ArrowRight } from 'lucide-react';
export function Roles() {
  const categories = [{
    icon: <Calculator className="w-6 h-6" data-id="element-219" />,
    title: 'Accounting & Finance',
    roles: ['Financial Analysts', 'Accountants', 'Bookkeepers', 'Controllers']
  }, {
    icon: <Settings className="w-6 h-6" data-id="element-220" />,
    title: 'Operations & Admin',
    roles: ['Operations Managers', 'Executive Assistants', 'Project Managers', 'Data Entry']
  }, {
    icon: <HeadphonesIcon className="w-6 h-6" data-id="element-221" />,
    title: 'Sales & Customer Success',
    roles: ['Account Executives', 'SDRs / BDRs', 'Customer Success Managers', 'Support Specialists']
  }, {
    icon: <Megaphone className="w-6 h-6" data-id="element-222" />,
    title: 'Marketing & Creative',
    roles: ['Digital Marketers', 'Content Creators', 'Graphic Designers', 'Social Media Managers']
  }, {
    icon: <Code2 className="w-6 h-6" data-id="element-223" />,
    title: 'Technology & Data',
    roles: ['Software Engineers', 'QA Testers', 'Data Analysts', 'IT Support']
  }, {
    icon: <Users2 className="w-6 h-6" data-id="element-224" />,
    title: 'HR & Recruiting',
    roles: ['HR Generalists', 'Technical Recruiters', 'Talent Acquisition', 'Onboarding Specialists']
  }];
  return <section id="roles" className="py-24 bg-navy" data-id="element-225">
      <div className="max-w-7xl mx-auto px-6" data-id="element-226">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-227">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold mb-6 text-white" data-id="element-228">
            The Talent Your Business Needs
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-229">
          {categories.map((category, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/5 p-8 rounded-3xl border border-white/10 backdrop-blur-sm hover:bg-white/10 hover:-translate-y-1 transition-all group cursor-default" data-id="element-230">
              <div className="w-12 h-12 rounded-2xl bg-white/10 flex items-center justify-center mb-6 group-hover:bg-white/20 transition-colors text-slate-200" data-id="element-231">
                {category.icon}
              </div>
              <h3 className="text-xl font-bold mb-4 text-white" data-id="element-232">
                {category.title}
              </h3>
              <ul className="space-y-3" data-id="element-233">
                {category.roles.map((role, rIndex) => <li key={rIndex} className="flex items-center text-slate-300 text-sm" data-id="element-234">
                    <div className="w-1.5 h-1.5 rounded-full bg-slate-500 mr-3 group-hover:bg-coral transition-colors" data-id="element-235" />
                    {role}
                  </li>)}
              </ul>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-gradient p-1 rounded-3xl" data-id="element-236">
          <div className="bg-white rounded-[22px] p-8 md:p-10 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-237">
            <div data-id="element-238">
              <h3 className="text-2xl font-bold text-navy mb-2" data-id="element-239">
                Need a different role?
              </h3>
              <p className="text-slate-600 max-w-2xl" data-id="element-240">
                We recruit beyond these categories and support specialized,
                leadership, and hard-to-fill positions.
              </p>
            </div>
            <a href="#contact" className="shrink-0 inline-flex items-center gap-2 px-6 py-3 bg-navy text-white font-semibold rounded-full hover:bg-navy-950 transition-colors" data-id="element-241">
              Let's Discuss <ArrowRight className="w-4 h-4" data-id="element-242" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}